module.exports = __webpack_public_path__ + "static/media/contactanos.9f0a6301.png";